<template>
  <div class="detail-wrap">
    <el-form ref="editForm" :model="formData">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info"/>
          {{ dataId ? '查看' : '新增' }}上帐科目
        </div>
        <div class="fr">
<!--          <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-refresh-right">重置-->
<!--          </el-button>-->
          <el-button type="primary" class="button-sty" icon="el-icon-check"
                     v-if="(fin_subject_edit && formData.id != null) || (fin_subject_add && formData.id == null)"
                     @click="saveData">保存</el-button>
        </div>
      </div>
      <div>

        <!-- 品牌信息 -->
        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <div class="title first">
              <b>主信息</b>
            </div>
            <table class="table-detail">
              <tbody>
              <tr>
                <th>
                  <em class="f-red">*</em>
                  科目编码
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.finCode" @blur="inspectionCode" clearable/>
                </td>
                <th>
                  <em class="f-red">*</em>
                  科目名称
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.finName" @blur="inspectionName" clearable/>
                </td>
                <th>
                  <em class="f-red">*</em>
                  计算符号
                </th>
                <td>
                  <el-select v-model="formData.symbols">
                    <el-option label="减号—" :value="-1"/>
                    <el-option label="不加不减" :value="0"/>
                    <el-option label="加号+" :value="1"/>
                  </el-select>
                </td>
                <th>
                  <em class="f-red">*</em>
                  启用
                </th>
                <td>
                  <el-select v-model="formData.usable">
                    <el-option label="禁用" :value="0"/>
                    <el-option label="启用" :value="1"/>
                  </el-select>
                </td>
              </tr>
              <tr>
                <th>
                  <em class="f-red">*</em>
                  排序
                </th>
                <td>
                  <el-input-number :min="0" :max="99" size="small" v-model="formData.seq"/>
                </td>
              </tr>
              <tr>
                <th>创建人</th>
                <td>{{ formData.createBy }}</td>
                <th>创建时间</th>
                <td>{{ formData.createTime }}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="d-item">
            <div class="title first"><b>属性设置</b></div>
            <table class="table-detail">
              <tbody>
              <tr>
                <th>
                  收款银行名称
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.inBankName" clearable/>
                </td>
                <th>
                  收款银行帐户名称
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.inBankAccountName" clearable/>
                </td>
                <th>
                  收款银行帐号
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.inBankAccount" clearable/>
                </td>
                <th>
                  是否网点可选
                </th>
                <td>
                  <el-radio v-model="formData.siteChoose" :label="0">否</el-radio>
                  <el-radio v-model="formData.siteChoose" :label="1">是</el-radio>
                </td>
              </tr>
              <tr>
                <th>
                  <em class="f-red">*</em>
                  是否保证金科目
                </th>
                <td>
                  <el-radio v-model="formData.isDeposit" :label="0">否</el-radio>
                  <el-radio v-model="formData.isDeposit" :label="1">是</el-radio>
                </td>
                <th>
                  <em class="f-red">*</em>
                  是否配件期初科目
                </th>
                <td>
                  <el-radio v-model="formData.isPartsBalance" :label="0">否</el-radio>
                  <el-radio v-model="formData.isPartsBalance" :label="1">是</el-radio>
                </td>
                <th>
                  <em class="f-red">*</em>
                  是否配件打款科目
                </th>
                <td>
                  <el-radio v-model="formData.isPartsMoney" :label="0">否</el-radio>
                  <el-radio v-model="formData.isPartsMoney" :label="1">是</el-radio>
                </td>
                <th>
                  <em class="f-red">*</em>
                  是否配件授信科目
                </th>
                <td>
                  <el-radio v-model="formData.isPartsCreditMoney" :label="0">否</el-radio>
                  <el-radio v-model="formData.isPartsCreditMoney" :label="1">是</el-radio>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </el-form>
<!--    <productCategoryDialog v-if="showProductCategoryDialog" :visiable.sync="showProductCategoryDialog" multi="false"-->
<!--                           @confirm="confirmCategory"/>-->
  </div>
</template>
<script>
import {
  initVxeTable
} from '@/const/crud/admin/table';
import Tinymce from '@/components/Tinymce';
import request from "@/router/axios";
import api from "@/api/projectApi";
import {editPageMixins} from "@/mixins/tabChang";
import {mapGetters} from "vuex";

export default {
  mixins: [editPageMixins],
  name: 'edit',
  props: {
    _dataId: [String, Number]
  },
  components: {
    Tinymce,
  },
  data() {
    return {
      fin_subject_add: false,
      fin_subject_edit: false,
      dataId: '',
      activeName: 'first',
      getDataUrl: '/basic/basFinSubject/getById',
      updateDataUrl: '/basic/basFinSubject/update',
      saveDataUrl: '/basic/basFinSubject/add',
      formData: {
        id: null,
        finCode: '',  // 科目编码,同厂商下惟一
        finName: '',  // 科目名称,同厂商下惟一
        symbols: 1,  // 计算符号：1表示+，-1表示-，0表示不加不减
        seq: 0,  // 排序
        usable: 1,  // 启用:0禁用；1启用
        isDeposit: 0,  // 是否保证金科目：0否1是
        isPartsBalance: 0,  // 是否配件期初科目：0否1是
        isPartsMoney: 0,  // 是否配件打款科目：0否1是
        isPartsCreditMoney: 0,  // 是否配件授信科目：0否1是
        siteChoose: 0,  // 是否网点可选：0否1是
        inBankName: '',  // 收款银行名称
        inBankAccountName: '',  // 收款银行帐户名称
        inBankAccount: '',  // 收款银行帐号
      },
      isEdit: false,
    };
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  created() {
    this.fin_subject_edit = this.permissions['fin_subject_edit']
    this.fin_subject_add = this.permissions['fin_subject_add']

    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
  },

  mounted() {
    this.getData();
  },

  methods: {
    inspectionName() {
      if (this.formData.finName) {
        this.$http({
          url: api.basFinSubject.inspectionNameUrl,
          method: 'post',
          data: {
            value: this.formData.finName,
            id: this.formData.id,
          }
        }).then(res => {
          if (!res.data.data) {
            this.$message.warning("科目名称已存在，请重新输入")
            this.formData.finName = null
          }
        })
      }
    },
    inspectionCode() {
      if (this.formData.finCode) {
        this.$http({
          url: api.basFinSubject.inspectionCodeUrl,
          method: 'post',
          data: {
            value: this.formData.finCode,
            id: this.formData.id,
          }
        }).then(res => {
          if (!res.data.data) {
            this.$message.warning("科目编码已存在，请重新输入")
            this.formData.finCode = null
          }
        })
      }
    },


    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http({
          url: this.getDataUrl,
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          this.formData = response.data.data
        })
      }
    },

    saveData() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$baseConfirm('您确定要保存吗？').then(() => {
            this.$mask.open()

            this.$http({
              url: this.isEdit ? this.updateDataUrl : this.saveDataUrl,
              method: `post`,
              data: this.formData,
              isLoading: true
            }).then(() => {
              this.$message.success("保存成功！");
              this.goBackIndex()
              this.$mask.close()

            }).catch(e => {
              console.error(e)
              this.$message.error("保存失败！");
              this.$mask.close()

            })
          })
        }
      })
    },

  },
};

</script>
<style lang="scss" scoped>
// 输入框的宽度
#containt .table-detail tbody tr td .el-input {
  width: 100% !important;
  width: 165px !important;
}
</style>
